export default __webpack_public_path__ + "static/media/NR-CW530HVK2.317b8e6b.jpg";